import { Helmet } from 'react-helmet-async';

export function StructuredData({ type, data }) {
  let structuredData = {};

  switch (type) {
    case 'organization':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Baklight",
        "description": "Director-led film production ecosystem in Mexico",
        "url": "https://baklight.emergent.host",
        "logo": "https://baklight.emergent.host/assets/logo.svg",
        "image": "https://baklight.emergent.host/assets/og-image.jpg",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Guadalajara",
          "addressRegion": "Jalisco",
          "addressCountry": "MX"
        },
        "sameAs": [
          "https://www.instagram.com/baklight",
          "https://www.facebook.com/baklight",
          "https://vimeo.com/baklight"
        ],
        "founder": {
          "@type": "Person",
          "name": "Paco Herrera",
          "jobTitle": "Director & Cinematographer"
        }
      };
      break;

    case 'article':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": data.title,
        "description": data.description,
        "image": data.image,
        "datePublished": data.publishedTime,
        "dateModified": data.modifiedTime || data.publishedTime,
        "author": {
          "@type": "Person",
          "name": data.author || "Paco Herrera"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Baklight",
          "logo": {
            "@type": "ImageObject",
            "url": "https://baklight.emergent.host/assets/logo.svg"
          }
        }
      };
      break;

    case 'project':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Movie",
        "name": data.title,
        "description": data.description,
        "image": data.image,
        "genre": data.category,
        "dateCreated": data.year?.toString(),
        "inLanguage": data.language || "es",
        "countryOfOrigin": {
          "@type": "Country",
          "name": "Mexico"
        },
        "productionCompany": {
          "@type": "Organization",
          "name": "Baklight",
          "url": "https://baklight.emergent.host"
        },
        "director": {
          "@type": "Person",
          "name": "Paco Herrera",
          "jobTitle": "Director & Cinematographer"
        },
        ...(data.video_url && {
          "embedUrl": data.video_url,
          "uploadDate": data.published_at
        }),
        ...(data.duration && {
          "duration": `PT${data.duration}M`
        }),
        ...(data.keywords && {
          "keywords": data.keywords
        })
      };
      break;

    case 'breadcrumb':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": data.items.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        }))
      };
      break;

    case 'faq':
      if (!data.items || data.items.length === 0) return null;
      structuredData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": data.items.map(item => ({
          "@type": "Question",
          "name": item.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": item.answer
          }
        }))
      };
      break;

    default:
      return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
